module.exports = __webpack_public_path__ + "assets/img/6.dae9a687.png";